import _styled from '@emotion/styled/base';
import { IconChevronUpSmall, IconChevronDownSmall } from '@hubble/icons/web';
import React__default from 'react';
import { useMedia } from 'react-use';
import { Button } from '../Button/index.js';
import { Flex } from '../Flex/index.js';
import { Text } from '../Text/index.js';
import { validComponents, SECONDARY_NAV_HEIGHT_COLLAPSED } from './constants.js';
import { ContentWrapper, StyledHeader, StyledContent, StyledForm, StyledSidePanel, StyledFooter, StyledSecondaryNav } from './styles.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { mediaQuery } from '../primitives/media-queries.js';
import { grid, elevation } from '@hubble/tokens/web';

const Header = props => {
  if (!props.children) return null;
  return jsx(ContentWrapper, {
    children: jsx(StyledHeader, {
      "data-testid": validComponents.Header,
      ...props,
      children: props.children
    })
  });
};
Header.displayName = 'PageLayout.Header';
const Content = props => {
  return jsx(StyledContent, {
    "data-testid": validComponents.Content,
    ...props
  });
};
Content.displayName = validComponents.Content;
const Form = props => {
  return jsx(StyledForm, {
    "data-testid": validComponents.Form,
    ...props
  });
};
Form.displayName = validComponents.Form;
const SidePanel = props => {
  return jsx(StyledSidePanel, {
    "data-testid": validComponents.SidePanel,
    ...props
  });
};
SidePanel.displayName = validComponents.SidePanel;
const Footer = props => {
  return jsx(StyledFooter, {
    "data-testid": validComponents.Footer,
    ...props
  });
};
Footer.displayName = validComponents.Footer;
const DisclosureButton = _styled("button", {
  target: "ef4gt543"
})("-webkit-appearance:none;border-radius:0;text-align:inherit;background:none;box-shadow:none;cursor:pointer;border:none;color:inherit;font:inherit;outline:none;border:none;border-top:1px solid ", ({
  theme
}) => theme.colorScheme.border.primary, ";border-bottom:1px solid ", ({
  theme
}) => theme.colorScheme.border.primary, ";background:", ({
  theme
}) => theme.colorScheme.background.secondary, ";display:flex;width:100%;height:100%;align-items:center;justify-content:space-between;margin:0;padding:0 ", grid.main.xs.margin, ";cursor:pointer;height:", SECONDARY_NAV_HEIGHT_COLLAPSED, ";&:hover,&:focus{>[data-type='button']{background:", ({
  theme
}) => theme.colorScheme.action.background.tertiary.neutral.hover, ";}}");
const DisclosurePanel = _styled("div", {
  target: "ef4gt542"
})("background:", ({
  theme
}) => theme.colorScheme.elevated.background.menu, ";box-shadow:", elevation.menu, ";max-height:80%;overflow:auto;position:absolute;width:100%;padding:", grid.main.xs.margin, ";z-index:2;");
const Label = _styled(Text.Body, {
  target: "ef4gt541"
})({
  name: "szjn6i",
  styles: "overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex:1"
} );
const LabelWrapper = _styled(Flex, {
  target: "ef4gt540"
})({
  name: "ovk77c",
  styles: "min-width:0"
} );
const SecondaryNav = ({
  children,
  icon,
  label,
  ...rest
}) => {
  const isTabletAndUnder = useMedia(mediaQuery.tabletSmDown);
  const [isOpen, setIsOpen] = React__default.useState(false);
  const ID = 'hbl-secondarynav-disclosure-panel';
  const Icon = icon;
  React__default.useEffect(() => {
    setIsOpen(false);
  }, [isTabletAndUnder]);
  return jsx(StyledSecondaryNav, {
    "data-testid": validComponents.SecondaryNav,
    ...rest,
    children: isTabletAndUnder ? jsxs(React__default.Fragment, {
      children: [jsxs(DisclosureButton, {
        onClick: () => setIsOpen(prev => !prev),
        "aria-controls": ID,
        "aria-expanded": isOpen,
        children: [jsxs(LabelWrapper, {
          mr: 1,
          align: "center",
          children: [Icon ? jsx(Icon, {
            size: "sm"
          }) : null, jsx(Label, {
            ml: 1,
            bold: true,
            size: "sm",
            children: label
          })]
        }), jsx(Button.Tertiary, {
          as: "div",
          "data-type": "button",
          display: "inline-flex",
          icon: isOpen ? jsx(IconChevronUpSmall, {}) : jsx(IconChevronDownSmall, {}),
          tabIndex: -1,
          "aria-hidden": true
        })]
      }), isOpen ? jsx(DisclosurePanel, {
        id: ID,
        children: children
      }) : null]
    }) : children
  });
};
SecondaryNav.displayName = validComponents.SecondaryNav;

export { Content, Footer, Form, Header, SecondaryNav, SidePanel };
